<div>
  <div class="accuracy-title">
    <div>{{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.TITLE' | translate }}</div>
    <glxy-badge *ngIf="sourceSupportsListings" [color]="accuracySidebarBadgeColor()">
      <div>
        {{ accuracyText[isListingVerified && accuracy?.status === 2 ? 1 : accuracy?.status]?.Sidebar | translate }}
      </div>
    </glxy-badge>
  </div>
  <ng-container *ngIf="!sourceSupportsListings">
    <div class="accuracy-image">
      <img src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/void.svg" />
      <div>
        {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.NOT_AVAILABLE' | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="sourceSupportsListings">
    <ng-container *ngIf="accuracy?.status === notFoundStatus && isSyncingEnabled">
      @if (creatingListing()) {
        <div class="accuracy-subtitle">
          <div>
            {{ 'LISTING_SYNC.SOURCE_MENU.CREATING_LISTING' | translate: { source: sourceName, days: daysToPublish() } }}
          </div>
        </div>
      } @else {
        <div class="accuracy-image">
          <img src="https://vstatic-prod.apigateway.co/listing-builder-client/assets/images/searching-accuracy.svg" />
          <div>
            {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.SEARCHING' | translate }}
          </div>
        </div>
      }
    </ng-container>
    @if (accuracy?.status === inaccurateStatus) {
      <div class="accuracy-subtitle">
        {{ 'LISTING_SYNC.LSP_ADDON.COLUMNS.ACCURACY.WARNING' | translate }}
        <a (click)="navigateToListingProfile()">{{ 'NAVBAR.LISTING_PROFILE' | translate }}</a>
      </div>
    }
    @if (canMarkAsAccurate(accuracy?.status)) {
      <mat-slide-toggle
        class="accuracy-toogle-button"
        (change)="markListingAccurateEvent($event)"
        [(ngModel)]="isListingVerified"
        >Mark as accurate</mat-slide-toggle
      >
    }
    <ng-container *ngIf="accuracy?.anchorData">
      <div class="info-comparison-row">
        <mat-icon class="anchor-data-icon">business</mat-icon>
        <div class="anchor-data-container">
          <span [class.mark-inaccurate]="!accuracy.anchorDataMatches?.companyName && !isListingVerified">
            {{ accuracy.anchorData?.companyName || '--' }}
          </span>
        </div>
      </div>
      <div class="info-comparison-row" *ngIf="sourceSupportsListings">
        <mat-icon class="anchor-data-icon">room</mat-icon>
        <div class="anchor-data-container">
          <div [class.mark-inaccurate]="!accuracy.anchorDataMatches?.address && !isListingVerified">
            {{ accuracy.anchorData?.address || '--' }}
          </div>
          <div>
            <span [class.mark-inaccurate]="!accuracy.anchorDataMatches?.city && !isListingVerified">
              {{ accuracy.anchorData?.city || '--' }},
            </span>
            <span [class.mark-inaccurate]="!accuracy.anchorDataMatches?.state && !isListingVerified">
              {{ accuracy.anchorData?.state || '--' }},
            </span>
            <span>
              {{ accuracy.anchorData?.country || '--' }}
            </span>
          </div>
          <div [class.mark-inaccurate]="!accuracy.anchorDataMatches?.zip && !isListingVerified">
            {{ accuracy.anchorData?.zip || '--' }}
          </div>
        </div>
      </div>
      <div class="info-comparison-row">
        <mat-icon class="anchor-data-icon">phone</mat-icon>
        <div class="anchor-data-container">
          <span [class.mark-inaccurate]="!accuracy.anchorDataMatches?.phone && !isListingVerified">
            {{ accuracy.anchorData?.phone || '--' }}
          </span>
        </div>
      </div>
      <div class="info-comparison-row">
        <mat-icon class="anchor-data-icon">link</mat-icon>
        <div class="anchor-data-container">
          <span [class.mark-inaccurate]="!accuracy.anchorDataMatches?.website && !isListingVerified">
            {{ accuracy.anchorData?.website || '--' }}
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
